import { AxiosResponse } from 'axios';
import * as _ from 'lodash';
import { put } from 'redux-saga/effects';
import { api } from '../../libs';
import { fetchApplicationsSuccess } from '../actions/applications';
import { loginError } from '../actions/auth';
import {
  banJobSuccess,
  cancelJobSuccess,
  fetchJobDetailSuccess,
  fetchJobsSuccess,
  IJobBanRequestAction,
  IJobCancelRequestAction,
  IJobDetailFetchRequestAction,
  IJobsFetchRequestAction,
  jobsError,
} from '../actions/jobs';
import { IApplication } from '../types/application';
import { IJob } from '../types/job';
import { IUser } from '../types/user';

export function* fetchJobsSaga(action: IJobsFetchRequestAction) {
  try {
    const response: AxiosResponse = yield api.jobs.getAllJobs(action.payload);

    const fetchedJobs: IJob[] = _.map(response.data.jobs, (job: IJob) => {
      const user = _.find(response.data.users, u => u.id === job.author_id);
      const stats = _.find(response.data.stats, s => s.job_id === job.id);
      return { ...job, author: user, stats: stats };
    });

    yield put(fetchJobsSuccess(fetchedJobs, response.data.page_info));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(jobsError(err.message));
    }
  }
}

export function* fetchJobDetailSaga(action: IJobDetailFetchRequestAction) {
  try {
    const jobResponse: AxiosResponse = yield api.jobs.getJob(action.payload.id);
    const appResponse: AxiosResponse = yield api.applications.getAll(action.payload.id, {limit: 1000});

    const fetchedJob: IJob = jobResponse.data.data;
    const users: IUser[] = appResponse.data.users;

    const applications: IApplication[] = _.map(appResponse.data.applications, app => {
      const user = _.find(users, u => u.id === app.candidate_id);
      return { ...app, candidate: user };
    });

    yield put(fetchJobDetailSuccess({ ...fetchedJob, applications: applications }));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(jobsError(err.message));
    }
  }
}

export function* banJobSaga(action: IJobBanRequestAction) {
  try {
    yield api.jobs.ban(action.payload.id);
    yield put(banJobSuccess(action.payload.id));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(jobsError(err.message));
    }
  }
}

export function* cancelJobSaga(action: IJobCancelRequestAction) {
  try {
    const res = yield api.jobs.cancel(action.payload.id);
    yield put(cancelJobSuccess(res.data.data));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(jobsError(err.message));
    }
  }
}

export function* fetchApplicationsSaga(action: IJobsFetchRequestAction) {
  try {
    const fetchedJobs: IApplication[] = [];
    yield put(
      fetchApplicationsSuccess(fetchedJobs, {
        has_next: false,
        has_previous: false,
      })
    );
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(jobsError(err.message));
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/jobs.ts